export interface PromoCodeType {
  id: number;
  name: string;
  productGroupId: number;
  productGroup: string;
  codes: string[];
}

export const promoCodeInitialState = {
  id: 0,
  name: '',
  productGroupId: 0,
  productGroup: '',
  codes: [],
};

export interface ProductGroupType {
  id: number;
  groupName: string;
  isDefault: boolean;
  plan: string;
  planId: number;
  isGifts: boolean;
}
